module.exports = __webpack_public_path__ + "e8de3d978edf58920d63e65dc4ed3bb8.png";